import { defineMessages } from "react-intl";

const messages = defineMessages({
    next: {
        id: "general.next",
    },
    back: {
        id: "general.back",
    },
    homework: {
        id: "homework",
    },
    key: {
        id: "join.enterKey",
    },
    homeworkClass: {
        id: "homework.class",
    },
    rememberKey: {
        id: "homework.rememberKey",
    },
    rememberClassId: {
        id: "homework.rememberClassId",
    },
    progressKey: {
        id: "homework.progress.key",
    },
    progressClass: {
        id: "homework.progress.class",
    },
    progressHomework: {
        id: "homework.progress.homework",
    },
    description: {
        id: "homework.student.description",
    },
    attention: {
        id: "homework.student.attention.native",
    },
    description1: {
        id: "homework.student.attention.native.1",
    },
    description2: {
        id: "homework.student.attention.web.2",
    },
    description3: {
        id: "homework.student.attention.native.3",
    },
    description4: {
        id: "homework.student.attention.native.4",
    },
    description5: {
        id: "homework.student.attention.native.5",
    },
    description6: {
        id: "homework.student.attention.web.7",
    },

});

export default messages;
